import { Datepicker } from "@/components/datepicker/Datepicker.tsx";
import { Button, Modal, ModalProps, Stack, useModals } from "@skailer-com/uikit";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export interface ChooseDateModalProps extends ModalProps {
  value: Date | null;
  onSave: (value: Date | null) => void;
}

export function ChooseDateModal({ value, onSave, ...props }: ChooseDateModalProps) {
  const { id } = props;
  const { t } = useTranslation();
  const { close } = useModals();

  const [date, setDate] = useState<Date | null>(value);

  const onSubmit = () => {
    onSave(date);
    close(id);
  };

  return (
    <Modal
      {...props}
      title={t("reporting:people_analytics_scope_choose_date")}
      withCloser
      size="md"
      actions={
        <Stack gap="sm">
          <Button type="button" size="lg" onClick={onSubmit}>
            {t("common:save")}
          </Button>
        </Stack>
      }
    >
      <Datepicker value={date} label={t("common:date")} onChange={setDate} />
    </Modal>
  );
}
